/** 태블릿 QR 세션 결과 공유 — docs/session-result-qr-share.md (v1) */

export type SessionResultQueryV1 = {
  v: 1;
  sid: string;
  bpm: number | null;
  hrv: number | null;
  relax: number | null;
  stress: string;
  min: number | null;
  t: number | null;
  note: string;
  hl: string;
  sl: string;
  src: string;
  set: number | null;
};

const DEFAULT_HEADLINE = '세션 결과';
const DEFAULT_SUBLINE = 'SoundPill 스트레스 안정 세션 측정 결과입니다.';

function parseOptionalNumber(value: string | null): number | null {
  if (value == null || value.trim() === '') return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

function decodeParam(value: string | null): string {
  if (value == null) return '';
  try {
    return decodeURIComponent(value.replace(/\+/g, ' '));
  } catch {
    return value;
  }
}

/** URLSearchParams / location.search → v1 요약 (필수 필드 없으면 null) */
export function parseSessionResultQuery(search: string | URLSearchParams): SessionResultQueryV1 | null {
  const params = typeof search === 'string' ? new URLSearchParams(search.startsWith('?') ? search : `?${search}`) : search;

  const v = params.get('v');
  if (v !== '1') return null;

  const sid = decodeParam(params.get('sid')).trim();
  if (!sid) return null;

  const bpm = parseOptionalNumber(params.get('bpm'));
  const hrv = parseOptionalNumber(params.get('hrv'));
  const relax = parseOptionalNumber(params.get('relax'));
  const min = parseOptionalNumber(params.get('min'));

  // 핵심 측정값 중 하나라도 있어야 결과 UI로 간주
  if (bpm == null && hrv == null && relax == null && min == null) {
    return null;
  }

  return {
    v: 1,
    sid,
    bpm,
    hrv,
    relax,
    stress: decodeParam(params.get('stress')).trim() || '--',
    min,
    t: parseOptionalNumber(params.get('t')),
    note: decodeParam(params.get('note')).trim(),
    hl: decodeParam(params.get('hl')).trim() || DEFAULT_HEADLINE,
    sl: decodeParam(params.get('sl')).trim() || DEFAULT_SUBLINE,
    src: decodeParam(params.get('src')).trim() || 'tablet',
    set: parseOptionalNumber(params.get('set')),
  };
}

export function formatSessionDateTime(ts: number): string {
  return new Date(ts).toLocaleString('ko-KR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function displayMetric(value: number | null, fallback = '--'): string {
  if (value == null) return fallback;
  return String(Math.round(value));
}

/** URL에 isKakaoShare=true(또는 1)이면 진입 시 카카오 공유 자동 실행 */
export function isKakaoShareEnabled(search: string | URLSearchParams): boolean {
  const params = typeof search === 'string' ? new URLSearchParams(search.startsWith('?') ? search : `?${search}`) : search;
  const value = params.get('isKakaoShare')?.trim().toLowerCase();
  return value === 'true' || value === '1';
}
